import React, {useImperativeHandle, forwardRef, useState} from "react";

import {View}  from 'react-native'

import cores from '../util/cores'



const Bloco = forwardRef((props, ref) => {

    const [mostrar, setMostrar] = useState(true)  
	
	
	useImperativeHandle(ref, () => ({
		mostrar: () => setMostrar(true),
		ocultar: () => setMostrar(false)
	}));
    
    return (
		<View style={{
			flex: 1,
			paddingTop: 5,
			paddingLeft: 10,
			paddingRight: 10,
			paddingBottom: 5,
			borderRadius:10,
			backgroundColor: cores.fundo_claro,
			marginTop: 5,
			marginBottom: 5
			}}>
			<View style={{flex: 1}}>    
				{props.children}
			</View> 
		</View>   
	)
   
});

export default Bloco;